module.exports = "<div id=\"flashMessages\">\n  <div class=\"flash-message alert {{findClass(message)}}\" *ngFor='let message of messages'>\n    <div [innerHtml]=\"message.message\"></div>\n    <button class=\"close\" *ngIf=\"showClose(message)\" (click)=\"closeMessage(message)\">\n      <span>{{ 'COMMON.BUTTON.CLOSE' | translate }}</span>\n    </button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/flash-messages/component/flash.messages.component.html
// module id = vFLc
// module chunks = 0